module.exports = __webpack_public_path__ + "static/media/marker.1bbe09eb.png";